/**
 * Decline Budget Confirmation Modal
 *
 * Displays a confirmation dialog when user attempts to decline a budget.
 * Uses BudgetModalTemplate for consistent styling with other budget modals.
 *
 * @component
 */

import React from 'react'
import { Message } from 'semantic-ui-react'
import BudgetModalTemplate from './BudgetModalTemplate'

interface DeclineBudgetConfirmationModalProps {
  open: boolean
  budgetName: string
  onClose: () => void
  onConfirm: () => void
  isDeclining: boolean
}

/**
 * Confirmation modal for budget decline action
 * @param open - Controls modal visibility
 * @param budgetName - Name of budget being declined
 * @param onClose - Called when modal is closed/cancelled
 * @param onConfirm - Called when user confirms decline
 * @param isDeclining - Whether decline operation is in progress
 */
const DeclineBudgetConfirmationModal: React.FC<DeclineBudgetConfirmationModalProps> = ({
  open,
  budgetName,
  onClose,
  onConfirm,
  isDeclining
}) => {
  return (
    <BudgetModalTemplate
      open={open}
      onClose={onClose}
      title="Decline Budget"
      icon="times circle"
      width="500px"
      hasChanges={false}
      onSave={onConfirm}
      isSaving={isDeclining}
      saveLabel="Decline"
      savingLabel="Declining..."
      cancelLabel="Cancel"
      minHeight="10rem"
    >
      <Message warning>
        <Message.Header>Are you sure you want to decline this budget?</Message.Header>
        <p style={{ marginTop: '1rem' }}>
          Budget: <strong>{budgetName}</strong>
        </p>
        <p style={{ marginTop: '0.5rem' }}>
          This will mark the budget as declined. You can change the status later if needed.
        </p>
      </Message>
    </BudgetModalTemplate>
  )
}

export default DeclineBudgetConfirmationModal
